<template>
    <v-flex xs12>
        <v-card height="100%" @dragenter="prevent" @dragleave="prevent" @dragover="prevent" @drop="addFiles">
            <v-toolbar>
                <v-toolbar-title>Ajout de documents dans "{{ currentDirectoryName }}"</v-toolbar-title>

                <v-spacer></v-spacer>

                <v-btn class="light-blue white--text darken-1" @click="browseFiles">
                    <v-icon>add</v-icon>
                </v-btn>

                <router-link v-if="finished" :to="{ name: 'directory-show', params: { slug: currentDirectory.slug }}">
                    <v-btn class="green white--text lighten-1">
                        Terminé
                    </v-btn>
                </router-link>
            </v-toolbar>

            <v-content v-show="false">
                <input ref="inputFile" type="file" multiple @change="addFiles">
            </v-content>

            <v-list>
                <DocumentDropZoneItem v-for="uploadedFile in uploadList" :key="uploadedFile.id" :uploaded-file="uploadedFile"/>
            </v-list>
        </v-card>
    </v-flex>
</template>

<script>
    import {mapGetters} from "vuex";
    import DocumentDropZoneItem from "./DocumentDropZoneItem";
    import {DocumentService} from "../../services/document.service";

    export default {
        name: "DocumentDropZone",
        components: {DocumentDropZoneItem},
        data: () => ({
            finished: true,
            uploadList: []
        }),
        computed: {
            ...mapGetters(["currentDirectory", "currentDirectoryName", "documents"]),
            inputFile: function () {
                return this.$refs.inputFile;
            }
        },
        watch: {
            uploadList: function () {
                this.processUpload();
            },
            finished: function () {
                this.processUpload();
            }
        },
        methods: {
            /**
             * Ajoute des fichiers à la queue
             */
            addFiles(event) {
                event.preventDefault();
                let files = ('dataTransfer' in event && event.dataTransfer.files.length > 0) ? event.dataTransfer.files : this.inputFile.files;

                for (let i = 0; i < files.length; i++) {
                    let file = files[i];

                    this.uploadList.push({
                        id: Math.random().toString(36),
                        uploading: false,
                        done: false,
                        succeed: false,
                        isCopy: this.isCopy(file),
                        file: file
                    });
                }
            },
            /**
             * Ouvre l'input file
             */
            browseFiles() {
                this.inputFile.click();
            },
            /**
             * Vérifie si le fichier est déjà dans la queue
             */
            isCopy(file) {
                let uploading = false;

                this.uploadList.forEach((uploadFile) => {
                    if (file.name === uploadFile.file.name) {
                        uploading = true;
                    }
                });

                if (!uploading) {
                    for (let index in this.documents) {
                        let document = this.documents[index];

                        if (document.filename === file.name) {
                            uploading = true;
                            break;
                        }
                    }
                }

                return uploading;
            },
            /**
             * Evite les comportements non souhaités
             */
            prevent(event) {
                event.preventDefault();
            },
            /**
             * Lance l'upload de la queue
             */
            processUpload() {
                for (let index in this.uploadList) {
                    let uploadFile = this.uploadList[index];
                    if (this.finished && !uploadFile.uploading && !uploadFile.done && !uploadFile.isCopy) {
                        this.upload(this.uploadList[index]);
                        break;
                    }
                }
            },
            /**
             * Upload un fichier
             */
            upload(uploadFile) {
                this.finished = false;

                let payload = {
                    directory: this.currentDirectory.slug,
                    file: uploadFile.file
                };

                let config = {
                    onUploadProgress: (progressEvent) => {
                        let progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        uploadFile.progress = progress > 100 ? 100 : (progress < 0 ? 0 : progress);
                    }
                };

                uploadFile.uploading = true;
                DocumentService.add(payload, config).then(() => {
                    uploadFile.succeed = true;
                }).catch(() => {
                    uploadFile.succeed = false;
                }).finally(() => {
                    uploadFile.uploading = false;
                    uploadFile.done = true;
                    this.finished = true;
                });
            }
        }
    };
</script>

<style scoped lang="scss">
</style>
